'use strict';

function CompanyProductsService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/products/:productId', {}, {
    'update':  {
      method: 'PUT'
    },
    'updatePrice': {
      method: 'PUT',
      url: config.apiBase + '/companies/:companyId/products/:productId/prices'
    },
    'priceDelete': {
      method: 'delete',
      url: config.apiBase + '/companies/:companyId/products/:productId/prices/:priceId'
    },
    'priceListUpdate': {
      method: 'PUT',
      url: config.apiBase + '/companies/:companyId/products/pricelists'
    },
    'priceListQuery': {
      method: 'GET',
      url: config.apiBase + '/companies/:companyId/products/pricelists',
      isArray: true
    },
    'priceListDelete': {
      method: 'DELETE',
      url: config.apiBase + '/companies/:companyId/products/pricelists/:priceListId'
    },
    'priceListDetail': {
      method: 'GET',
      url: config.apiBase + '/companies/:companyId/products/pricelists/:priceListId',
      isArray: false
    },
    'updateImage': {
      method: 'PUT',
      url: config.apiBase + '/companies/:companyId/products/:productId/image/:imageId'
    },
    'ImageDelete': {
      method: 'DELETE',
      url: config.apiBase + '/companies/:companyId/products/:productId/image/:imageId'
    }
  });
}

angular.module('dokiv')
  .factory('CompanyProductsService', ['$resource', 'config', CompanyProductsService]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/products/CompanyProductsService.js
// module id = 20
// module chunks = 0